// This file is auto-generated by dibs-icons script
import { type FC } from 'react';
import Search20 from './Search20';
import Search20Circle from './Search20Circle';
import Search24 from './Search24';
import Search24Circle from './Search24Circle';
import Search40 from './Search40';
import Search48 from './Search48';

type SearchProps = {
    variation: '20' | '20Circle' | '24' | '24Circle' | '40' | '48';
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const svgVariations = {
    Search20,
    Search20Circle,
    Search24,
    Search24Circle,
    Search40,
    Search48,
};

const Search: FC<SearchProps> = ({ variation, ...props }) => {
    const variationKey = `Search${variation}` as keyof typeof svgVariations;
    const Icon = svgVariations[variationKey];

    if (!Icon) {
        // eslint-disable-next-line no-console
        console.error(`"Search" icon variation ${variationKey} does not exist`);
        return null;
    }

    return <Icon {...props} />;
};

export default Search;
